'use client';

import React from 'react';
import ProjectSummaryGrid from './ProjectSummaryGrid';
import { Box, Grid, Paper, Typography } from '@mui/material';

const ProjectMgmtSummary = ({ totalProjects, projectsOverBudget, totalBaseCost, totalEFC, onLoaded }) => {
  const stats = [
    { label: 'Total Projects', value: totalProjects },
    { label: 'Projects Over Budget', value: projectsOverBudget },
    {
      label: 'Total Base Cost',
      value: new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(totalBaseCost),
    },
    {
      label: 'Total EFC',
      value: new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(totalEFC),
    },
  ];

  const cardStyles = {
    p: 3,
    borderLeft: '4px solid #1976D2',
    backgroundColor: '#F9F9F9',
    borderRadius: '8px',
    height: '100%',
  };

  return (
    <Box mt={4}>
      <Grid container spacing={2}>
        {stats.map((stat, idx) => (
          <Grid key={idx} item xs={12} md={3}>
            <Paper variant="outlined" sx={cardStyles}>
              <Typography variant="subtitle2" color="text.secondary">
                {stat.label}
              </Typography>
              <Typography
                variant="h6"
                noWrap
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  width: '100%',
                  textAlign: 'center',
                }}
              >
                {stat.value}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Box mt={4}>
        <ProjectSummaryGrid onLoaded={onLoaded} />
      </Box>
    </Box>
  );
};

export default ProjectMgmtSummary;
